import { useState, useCallback } from 'react';
import { getSummary } from 'js/social/api/ai_summaries_api';
import { AiButtonType, NewsType } from 'js/social/shared/types';

export const useAiSummary = (
  newsId: string | number,
  newsType: NewsType,
  type: AiButtonType | undefined,
  extra: object = {},
) => {
  const [summary, setSummary] = useState<string>();
  const [loading, setLoading] = useState(false);

  const fetchSummary = useCallback(async () => {
    if (loading || !type || summary) return;

    setLoading(true);
    try {
      const summary = await getSummary(newsId, newsType, type, extra);
      setSummary(summary);
    } finally {
      setLoading(false);
    }
  }, [newsId, newsType, type, extra, loading, summary]);

  const clearSummary = useCallback(() => {
    setSummary(undefined);
  }, []);

  return { loading, summary, fetchSummary, clearSummary };
};
